import { render, staticRenderFns } from "./Add&Minus.vue?vue&type=template&id=74d10417&scoped=true"
import script from "./Add&Minus.vue?vue&type=script&lang=js"
export * from "./Add&Minus.vue?vue&type=script&lang=js"
import style0 from "./Add&Minus.vue?vue&type=style&index=0&id=74d10417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d10417",
  null
  
)

export default component.exports